









































































































































































































































































































































































import { Prop, Component, Mixins, Watch } from 'vue-property-decorator';
import { FetchResult } from 'apollo-link';
// element
import {
  Card,
  Checkbox,
  Form,
  Button,
  FormItem,
  Input,
  Select,
  Option
} from 'element-ui';
import Avatar from '@/components/Avatar.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// services
import { taskService } from '@/services/TaskService';
import { channelService } from '@/services/ChannelService';

// mixin
import comment from '@/mixins/comment';

// types
import {
  CommunicationTypeEnum,
  CustomerFields,
  TaskFields,
  TaskInput,
  TaskAssigneeTypeEnum,
  TaskFields_assignee
} from '@/types/graphql/schemaTypes';

// gql
import fetchCustomersQuery from '@/graphql/queries/customers/FetchCustomers.gql';
import filterListQuery from '@/graphql/queries/operator/FilterList.gql';

// others
import debounce from 'lodash/debounce';
import format from 'date-fns/format';
import draggable from 'vuedraggable';

interface TaskTuple {
  fields: TaskFields | null;
  input: TaskInput;
}

@Component({
  components: {
    Avatar,
    draggable,
    UtcDatePicker,
    'el-button': Button,
    'el-card': Card,
    'el-checkbox': Checkbox,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option
  },
  apollo: {
    operators: {
      query: filterListQuery,
      prefetch: true,
      fetchPolicy: 'cache-and-network'
    },
    customers: {
      query: fetchCustomersQuery,
      fetchPolicy: 'cache-and-network',
      skip() {
        return !this.selectedTask;
      },
      variables() {
        return {
          organizationArgs: {
            customerOrganizationId:
              this.selectedTask && this.selectedTask.customerOrganization.id
          }
        };
      },
      update(data) {
        return data.organizationStaff.filter((customer: CustomerFields) => {
          return customer.status !== 'invited';
        });
      }
    }
  }
})
export default class TasksList extends Mixins(comment) {
  @Prop({ default: false, type: Boolean }) creation!: boolean;
  @Prop({ default: false, type: Boolean }) seeMore!: boolean;
  @Prop({ default: false, type: Boolean }) allowEdit!: boolean;
  @Prop({ default: false, type: Boolean }) isDrayageDisplayed?: boolean;
  @Prop({ default: '', type: String }) shipmentId!: string;
  @Prop({ default: () => [] }) tasks!: TaskFields[];

  private assigneeType: TaskAssigneeTypeEnum = TaskAssigneeTypeEnum.operator;
  private assigneeTypeOptions: TaskAssigneeTypeEnum[] = [
    TaskAssigneeTypeEnum.operator,
    TaskAssigneeTypeEnum.shipper
  ];

  private selectedAssignee: TaskFields_assignee | null = null;
  private taskTuples: TaskTuple[] = [];
  private selectedTaskId: string | null = null;
  private taskInput: TaskInput = {
    shipmentId: this.shipmentId,
    title: ''
  };

  avatar(task: TaskFields): null | string {
    return task?.assignee && task.assignee.avatar && task.assignee.avatar.url;
  }

  name(task: TaskFields): null | string {
    return task?.assignee && task.assignee.name;
  }

  private delayedSave = debounce(this.updateCurrentTask, 1500);

  private checkTask(currentTask: TaskTuple) {
    // shouldn't happen with the flow in UI but cancel event if we try to check a task that have
    // just been added in the front but creation failed and therefore we didn t receive a correct
    // id
    if (!currentTask.input.id) {
      return;
    }

    // set local value first
    this.toggleDateCheckbox(currentTask, 'doneAt', false);

    const mutationPromise = taskService.checkTasks({
      taskId: currentTask.input.id,
      done: !!currentTask.input.doneAt
    });

    this.mutationCallbacks(mutationPromise, 'checkTask');
  }

  private deleteTask(index: number) {
    const id = this.taskTuples[index]!.input.id!;

    if (this.selectedTaskId === id) {
      this.selectedTaskId = null;
    }

    this.$delete(this.taskTuples!, index);
    this.mutationCallbacks(taskService.deleteTask(id), 'deleteTask');
  }

  private openTaskDetails(taskId: string) {
    this.selectedTaskId =
      !this.allowEdit || this.selectedTaskId === taskId ? null : taskId;

    if (!this.selectedTaskTuple) {
      return;
    }

    if (this.selectedTask && this.selectedTask.assignee) {
      this.selectedAssignee = {
        id: this.selectedTask.assignee.id,
        name: this.selectedTask.assignee.name,
        assigneeType: this.selectedTask.assignee.assigneeType,
        avatar: this.selectedTask.assignee.avatar || null
      };
      this.assigneeType = this.selectedTask.assignee.assigneeType;
    } else {
      // If assignee is null, assigneeType is set via responsibleParty
      this.assigneeType =
        this.selectedTask.responsibleParty === 'operator'
          ? TaskAssigneeTypeEnum.operator
          : TaskAssigneeTypeEnum.shipper;
      this.selectedAssignee = null;
    }
  }

  // When assigneeType is 'shipper' make 'isPublic' always 'true'
  private updateIsPublicByAssigneeType() {
    const assigneeType = this.selectedTaskInput.assigneeType;

    if (assigneeType === 'shipper') {
      this.selectedTaskInput.isPublic = true;
    }
  }

  private selectAssigneeType() {
    this.selectedAssignee = null;

    if (this.selectedTaskInput) {
      this.selectedTaskInput.assigneeId = null;
      this.selectedTaskInput.assigneeType = this.assigneeType;
      this.updateIsPublicByAssigneeType();
    }
    this.updateCurrentTask();
  }

  private selectAssignee(assignee: TaskFields_assignee) {
    if (this.selectedTaskInput) {
      this.selectedTaskInput.assigneeId = assignee.id;
      this.selectedTaskInput.assigneeType = this.assigneeType;
      this.updateCurrentTask();
    }
  }

  private updateCurrentTask() {
    if (!this.selectedTask || !this.selectedTaskInput) {
      return;
    }

    const mutation = taskService.updateTask(
      this.selectedTask.id,
      this.selectedTaskInput
    );

    this.mutationCallbacks(mutation, 'updateTask');
  }

  private save() {
    if (this.taskInput.title) {
      this.taskTuples.push({
        fields: {
          assignee: null,
          customerOrganization: null,
          deadlineDate: null,
          description: null,
          doneAt: null,
          id: null,
          isPublic: false,
          reminderDate: null,
          responsibleParty: 'operator',
          shipmentId: this.shipmentId,
          shipmentReference: null,
          shipmentType: null,
          title: this.taskInput.title
        },
        input: { ...this.taskInput }
      });
    }

    this.taskInput.title = '';
    return taskService
      .upsertTasks(
        this.shipmentId,
        this.taskTuples.map((t) => t.input)
      )
      .then((response) => {
        if ((response!.data as any)!.upsertTasks) {
          this.$emit('refresh');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.created'),
            time: 3000
          });
        }
      })
      .catch(() => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 3000
        });
      });
  }

  private toggleDateCheckbox(
    task: TaskTuple,
    field: 'reminderDate' | 'doneAt',
    update: boolean
  ) {
    task.input[field] = task.input[field]
      ? null
      : format(new Date(), 'yyyy-MM-dd HH:mm');

    if (update) {
      this.save();
    }
  }

  private mutationCallbacks(
    promise: Promise<FetchResult<any, Record<string, any>>>,
    successKey: string
  ) {
    promise
      .then((response) => {
        if (response.data && response.data[successKey]) {
          // replace task by server response
          if (this.selectedTaskTuple) {
            this.selectedTaskTuple.fields = { ...response.data[successKey] };
          }

          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.created'),
            time: 1000
          });
        }
      })
      .catch(() => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 3000
        });
      });
  }

  @Watch('tasks', { deep: true, immediate: true })
  private regenerateTasksInputs(list: TaskFields[]) {
    if (!list) {
      return;
    }

    this.taskTuples = list.map((task) => {
      return {
        fields: task,
        input: {
          id: task.id,
          shipmentId: task.shipmentId,
          assigneeType: task.assignee && task.assignee.assigneeType,
          assigneeId: task.assignee && task.assignee.id,
          title: task.title,
          description: task.description,
          deadlineDate: task.deadlineDate,
          reminderDate: task.reminderDate,
          doneAt: task.doneAt,
          isPublic: task.isPublic || false
        }
      };
    });
  }

  get selectedTaskTuple(): TaskTuple | null {
    if (!this.selectedTaskId) {
      return null;
    }

    const task = this.taskTuples.find((tuple: TaskTuple) => {
      return tuple.input.id === this.selectedTaskId;
    });

    return task || null;
  }

  get selectedTask(): TaskFields | null {
    return this.selectedTaskTuple && this.selectedTaskTuple.fields;
  }

  get selectedTaskInput(): TaskInput | null {
    return this.selectedTaskTuple ? this.selectedTaskTuple.input : null;
  }

  get displayTaskDetails() {
    return !!(this.selectedTaskTuple && this.allowEdit);
  }

  get selectedTaskStatus() {
    return !!(this.selectedTaskTuple && this.selectedTaskTuple.input.doneAt);
  }

  get defaultText() {
    return `${process.env.VUE_APP_TAKETSURU_HOST}${this.$router.currentRoute.path}\n\n`;
  }
}
